import Serializer from 'umg-ember-backend/serializers/application';

export default class ProductWorkContributorSerializer extends Serializer {
  attrs = {
    productWork: 'work',
  };
}
